/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CodebookWarehouseResponse } from '../models/CodebookWarehouseResponse';
import type { CreateCodebookWarehouseRequest } from '../models/CreateCodebookWarehouseRequest';
import type { PageableCodebookWarehouseResponse } from '../models/PageableCodebookWarehouseResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CodebookWarehouseApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create codebook
   * @param requestBody
   * @returns any Create codebook
   * @throws ApiError
   */
  public createCodebookWarehouse(
    requestBody?: CreateCodebookWarehouseRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/codebook-warehouses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook Warehouse
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableCodebookWarehouseResponse Get codebook
   * @throws ApiError
   */
  public getCodebookWarehouse(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableCodebookWarehouseResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-warehouses',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook Warehouse by id
   * @param id
   * @returns CodebookWarehouseResponse Get codebook response
   * @throws ApiError
   */
  public getCodebookWarehouseById(
    id: string,
  ): CancelablePromise<CodebookWarehouseResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/codebook-warehouses/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * delete
   * @param id
   * @returns any deleted
   * @throws ApiError
   */
  public deleteCodebookWarehouse(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/codebook-warehouses/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Update
   * @param id
   * @param requestBody
   * @returns CodebookWarehouseResponse Update
   * @throws ApiError
   */
  public updateCodebookWarehouse(
    id: string,
    requestBody?: CreateCodebookWarehouseRequest,
  ): CancelablePromise<CodebookWarehouseResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/codebook-warehouses/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
